import { GhostPostOrPage, GhostPostsOrPages } from '../ghost-interfaces';
import getPagesByTag from './getPagesByTag';

/**
 * Prepare string to fetch ghost pages by tag
 *
 * @param assetSymbol
 * @param tab
 */
export const prepareGhostTag = (assetSymbol: string, tab: string): string => {
    return `${assetSymbol.toLowerCase()}-${tab}`;
};

/**
 * Return page for asset and tab (e.g. btc:overview)
 *
 * @param assetSymbol
 * @param tab
 */
export const getPageForAsset = async (assetSymbol: string, tab: string): Promise<GhostPostOrPage | null> => {
    const pages = await getPagesByTag([prepareGhostTag(assetSymbol, tab)]);

    return pages[0] ?? null;
};

/**
 * @param assetSymbol
 * @param tab
 * @param orderBy
 */
export const getPagesForAsset = async (
    assetSymbol: string,
    tab: string,
    orderBy: string = 'title ASC'
): Promise<GhostPostsOrPages> => {
    return getPagesByTag([prepareGhostTag(assetSymbol, tab)], 'all', '', orderBy);
};
